import { render, staticRenderFns } from "./ChatViewPopUp.vue?vue&type=template&id=1f466e54&"
import script from "./ChatViewPopUp.vue?vue&type=script&lang=js&"
export * from "./ChatViewPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ChatViewPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
})
